import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';
import ChangeOrders from '../../core/events/ChangeOrders';
import ButtonMediator from './ButtonMediator';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);

    mdr.actionMediator.start();

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    mdr.actionMediator.stop();
    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    mdr.state.state = mdr.model.menuOn ? 'x' : 'sandwich';
    mdr.state.disabled = !mdr.model.menuAvailable;

    // View: can be substituted by JS-animation
    mdr.el.dataset.state = mdr.state.state;
    mdr.el.dataset.eventLabel = mdr.model.menuOn ? 'Close menu' : 'Open menu';
    mdr.el.dataset.disabled = mdr.state.disabled;

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MENU_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.MENU_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const SandwichMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        actionMediator: ButtonMediator(el, ChangeOrders.SWITCH_MENU_STATE),
        state: {
            state: 'sandwich'
        }
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {SandwichMediator};
export default SandwichMediator;
